import { styled } from '@nexelem/deprecated-theme';

export const StyledContainer = styled('div')(() => {
  return {
    borderRadius: '4px',
    padding: '2px 1px',
    cursor: 'grab',
    opacity: 0,
    position: 'absolute',
    left: '0',
    top: '0',
    willChange: 'transform',
    ':active': {
      cursor: 'grabbing',
    },
    ':hover': {
      backgroundColor: '#efefef',
    },
    '.icon': {
      cursor: 'pointer',
      width: '16px',
      height: '16px',
      opacity: 0.3,
    },
  };
});

export const StyledLine = styled('div')(() => {
  return {
    pointerEvents: 'none',
    background: 'deepskyblue',
    height: '4px',
    position: 'absolute',
    left: '0',
    top: '0',
    opacity: 0,
    willChange: 'transform',
  };
});
